export default (value, innerReg) => {
    let reg = innerReg ? innerReg : /[^0-9.,]/g
    let _value = value.toString();

    if (_value.length > 0) {
        _value = _value.replace(reg, "")
    }


    _value = _value.replace(/,/g, '.')

    _value = _value.replace(/\.\./g, '.')

    return _value;
}